import { useContext } from 'react';
import { Api } from '@sodamnfoolish/sjc-backend-types';

import * as Virtual from '../../Components/VirtualGrid/VirtualGrid';
import { createBonkTokensSorter } from '../../utils/bubbles/sort';

import { LiveDataLetsBonkToken } from './LiveDataToken';
import { BonkLinkedContext } from './context/LinkedContext';
import { DexFeedColumn } from './DexFeedColumn';

import '../../utils/gradients.css';
import { BonkBubblesContext } from './context/BonkBubblesContext';
import { LetsBonkIcon } from '../../Components/icons/LetsBonkIcon';
import { isBonkSoundMuted } from './localStorage';
import { AppMode } from '../../types';
import { BN } from '@coral-xyz/anchor';

const sort = [
    {
        key: 'creationTime',
        value: 'Creation time',
        ASC: createBonkTokensSorter('deployBlockTime', 'ASC', Number),
        DESC: createBonkTokensSorter('deployBlockTime', 'DESC', Number),
    },
];

export const LetsBonkColumn = Virtual.createColumn<{
    mode: AppMode;
    onCreate: (token: Api.Bonk.DTO.LetsBonkToken) => void;
    onBuy: (token: Api.Bonk.DTO.LetsBonkToken, solAmount: BN) => void;
}>(({ id, width, mode, onCreate, onBuy }) => {
    const [store, remove] = useContext(BonkBubblesContext);

    return (
        <DexFeedColumn<Api.Bonk.DTO.LetsBonkToken>
            id={id}
            width={width}
            mode={mode}
            dexName='LetsBonk'
            bubbleContainerClassname='bg-[linear-gradient(to_bottom,var(--color-rust-chocolate),var(--color-dark-ember))]'
            dexIcon={<LetsBonkIcon />}
            store={store}
            sortItems={sort}
            defaultMuted={isBonkSoundMuted()}
            defaultMinLinkedTokens={parseInt(localStorage.getItem('bonkMinLinkedTokens') ?? '3')}
            onCreate={onCreate}
            onBuy={onBuy}
            onRemove={remove}
            onMinTokensChange={(min) => {
                localStorage.setItem('bonkMinLinkedTokens', String(min));
            }}
            onVolumeToggle={(muted) => {
                localStorage.setItem(isBonkSoundMuted.key, String(!muted));
            }}
            LiveDataToken={LiveDataLetsBonkToken}
            LinkedCtx={BonkLinkedContext}
        />
    );
});
